<template>
  <div>403 {{ $t("error_page_403") }}</div>
</template>

<script>
export default {
  name: "PermissionDenied",

  created() {
    this.$store.set("loading", false)
  },
}
</script>
